import { render, staticRenderFns } from "./ComentariosTabs.vue?vue&type=template&id=2d9eb999"
import script from "./ComentariosTabs.vue?vue&type=script&lang=js"
export * from "./ComentariosTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports